import { Card, Stack, Typography } from "@mui/material";
import { useLangContext } from "../../../../context/langContext";
import { PbxServerSchema } from "../../../../services/Schemas/PbxServer";
import { dateFormatter } from "../../../../utils/date-formatter";
import { Link } from "react-router-dom";

interface IBroadCastingMedSecProps {
  pbxServerInfo: PbxServerSchema;
}

export default function PbxServerMedSectionComponent({
  pbxServerInfo,
}: Readonly<IBroadCastingMedSecProps>) {
  const { lang } = useLangContext();
  return pbxServerInfo ? (
    <Stack>
      <Stack
        gap="24px"
        my="10px"
        direction="column"
        sx={{
          bgcolor: (theme) => theme.palette.gray[100],
          borderColor: (theme) => theme.palette.others.borderColor2,
          borderWidth: "1px",
          borderStyle: "solid",
          py: "18px",
          px: "16px",
          borderRadius: "8px",
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap="16px"
          flexWrap="wrap"
        >
          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              نام :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {pbxServerInfo.caption}
            </Typography>
          </Stack>
          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              نام کاربری :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {pbxServerInfo.username}
            </Typography>
          </Stack>
          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              لینک سرور :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.others.link}
              component={Link}
              sx={{
                textDecoration: "none",
              }}
              to={pbxServerInfo.server_url}
            >
              {pbxServerInfo.server_url}
            </Typography>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap="16px"
          flexWrap="wrap"
        >
          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              درایور pbx :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {pbxServerInfo.pbx_driver}
            </Typography>
          </Stack>

          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              آیدی تخته :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {pbxServerInfo.workspace_id}
            </Typography>
          </Stack>

          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              ایجاد شده در :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {dateFormatter({ lang, date: pbxServerInfo.created_at })}
            </Typography>
          </Stack>
        </Stack>

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap="16px"
          flexWrap="wrap"
        >
          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              آپدیت شده در :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {dateFormatter({ lang, date: pbxServerInfo.updated_at })}
            </Typography>
          </Stack>

          <Stack direction="row" gap="6px">
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dark[40]}
            >
              توضیحات :
            </Typography>
            <Typography
              variant="h6MediumBold"
              color={(theme) => theme.palette.dominant.main}
            >
              {pbxServerInfo.description}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  ) : (
    <Stack></Stack>
  );
}
